"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _DynoTypes = _interopRequireDefault(require("lead-flows-ui/constants/DynoTypes"));

var _UIGrid = _interopRequireDefault(require("UIComponents/grid/UIGrid"));

var _UIGridItem = _interopRequireDefault(require("UIComponents/grid/UIGridItem"));

var _DynoTypeSelection = _interopRequireDefault(require("./DynoTypeSelection"));

var _DynoEditorSubheader = _interopRequireDefault(require("./DynoEditorSubheader"));

var _RequestState = require("lead-flows-ui/utils/RequestState");

var _pop_over = _interopRequireDefault(require("bender-url!../../../img/dynos/pop_over.png"));

var _top = _interopRequireDefault(require("bender-url!../../../img/dynos/top.png"));

var _bottom_left = _interopRequireDefault(require("bender-url!../../../img/dynos/bottom_left.png"));

var _bottom_right = _interopRequireDefault(require("bender-url!../../../img/dynos/bottom_right.png"));

var _embedded = _interopRequireDefault(require("bender-url!../../../img/dynos/embedded.png"));

var PropTypes = _react.default.PropTypes;

var _default = _react.default.createClass({
  displayName: "DynoTypePanel",
  propTypes: {
    gates: PropTypes.object.isRequired,
    HubSettingsActions: _react.default.PropTypes.object.isRequired,
    hubSettingsUpdateRequestState: _react.default.PropTypes.instanceOf(_RequestState.RequestState).isRequired,
    type: PropTypes.oneOf(Object.keys(_DynoTypes.default)).isRequired,
    updateDyno: PropTypes.func.isRequired
  },
  getInitialState: function getInitialState() {
    return {};
  },
  langKey: function langKey(suffix) {
    return "leadFlowEditor.leadFlowTypeEditor." + suffix;
  },
  changeType: function changeType(newType) {
    var updateDyno = this.props.updateDyno;
    var dynoData = {
      type: newType
    };
    updateDyno(dynoData);
  },
  renderGridSecondRow: function renderGridSecondRow() {
    var _this = this;

    var type = this.props.type;

    if (this.props.gates['Leadin:Embedded']) {
      return _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
        size: 6
      }, _react.default.createElement(_DynoTypeSelection.default, {
        isNew: false,
        labelI18nKey: this.langKey('slideinBoxExampleLabel'),
        imageSrc: _bottom_right.default,
        selected: type === _DynoTypes.default.BOTTOM_LEFT || type === _DynoTypes.default.BOTTOM_RIGHT,
        onClick: function onClick() {
          return _this.changeType(_DynoTypes.default.BOTTOM_RIGHT);
        }
      })), _react.default.createElement(_UIGridItem.default, {
        size: 6
      }, _react.default.createElement(_DynoTypeSelection.default, {
        isNew: true,
        labelI18nKey: this.langKey('embeddedExampleLabel'),
        imageSrc: _embedded.default,
        selected: type === _DynoTypes.default.EMBEDDED,
        onClick: function onClick() {
          return _this.changeType(_DynoTypes.default.EMBEDDED);
        }
      })));
    }

    return _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
      size: 6
    }, _react.default.createElement(_DynoTypeSelection.default, {
      isNew: false,
      labelI18nKey: this.langKey('slideinBoxLeftExampleLabel'),
      imageSrc: _bottom_left.default,
      selected: type === _DynoTypes.default.BOTTOM_LEFT,
      onClick: function onClick() {
        return _this.changeType(_DynoTypes.default.BOTTOM_LEFT);
      }
    })), _react.default.createElement(_UIGridItem.default, {
      size: 6
    }, _react.default.createElement(_DynoTypeSelection.default, {
      isNew: false,
      labelI18nKey: this.langKey('slideinBoxRightExampleLabel'),
      imageSrc: _bottom_right.default,
      selected: type === _DynoTypes.default.BOTTOM_RIGHT,
      onClick: function onClick() {
        return _this.changeType(_DynoTypes.default.BOTTOM_RIGHT);
      }
    })));
  },
  render: function render() {
    var _this2 = this;

    var type = this.props.type;
    return _react.default.createElement("div", null, _react.default.createElement(_DynoEditorSubheader.default, null, _react.default.createElement(_FormattedMessage.default, {
      message: this.langKey('chooseLeadFlowType')
    })), _react.default.createElement(_UIGrid.default, null, _react.default.createElement(_UIGridItem.default, {
      size: 6
    }, _react.default.createElement(_DynoTypeSelection.default, {
      isNew: false,
      labelI18nKey: this.langKey('popUpBoxExampleLabel'),
      imageSrc: _pop_over.default,
      selected: type === _DynoTypes.default.POP_OVER,
      onClick: function onClick() {
        return _this2.changeType(_DynoTypes.default.POP_OVER);
      }
    })), _react.default.createElement(_UIGridItem.default, {
      size: 6
    }, _react.default.createElement(_DynoTypeSelection.default, {
      isNew: false,
      labelI18nKey: this.langKey('dropdownBannerExampleLabel'),
      imageSrc: _top.default,
      selected: type === _DynoTypes.default.TOP,
      onClick: function onClick() {
        return _this2.changeType(_DynoTypes.default.TOP);
      }
    }))), this.renderGridSecondRow());
  }
});

exports.default = _default;
module.exports = exports.default;